import { ForwardedRef, forwardRef, InputHTMLAttributes, useEffect, useState } from "react";
import styles from "./Input.module.scss";
import useForwardRef from "../../../../hooks/useForwardRef";
import { CheckedIcon } from '../../../../assets/icons';

type Props = {
	children?: React.ReactNode;
	label: string;
	placeholder: string;
	isPasswordInput?: boolean;
	error?: string;
	inputProps?: InputHTMLAttributes<HTMLInputElement>;
	isIcon?: boolean;
    styles?: any;
    required?: boolean,
    button?: {
        label: string,
        verified: boolean,
        function: () => void
    }
};

const Input = forwardRef((props: Props, ref: ForwardedRef<HTMLInputElement>) => {
    const { children, label, placeholder, isPasswordInput, inputProps, isIcon = true, button, required } = props;
	const [isPasswordHidden, setIsPasswordHidden] = useState<boolean>(true);
	const forwardedRef = useForwardRef(ref);

	let inputType;
	if (isPasswordInput) {
		inputType = isPasswordHidden ? "password" : "text";
	} else {
		inputType = "text";
	}



	const handleContainerClick = () => {
		if (forwardedRef?.current) {
			forwardedRef.current.focus();
		}
	};

	const handleVisibilityIconClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsPasswordHidden(!isPasswordHidden);
	};

	return (
		<button type="button" className={`${styles.inputContainer} ${props.styles?.inputContainer}  ${props.error && styles.errorInput}`} onClick={handleContainerClick}>
			{isIcon && <div className={`${styles.inputIcon} ${styles.orangeBg}`}>{children}</div>}
			<div className={styles.inputContent}>
				<span className={styles.inputLabel}>{label} {required && <div className={styles.asterix}>&nbsp;*</div>}</span>
				<input {...inputProps} className={styles.inputValue} type={inputType} placeholder={placeholder} ref={forwardedRef} />
				{props.error && <div className={styles.error}>{props.error}</div>}
			</div>
			{isPasswordInput && (
				<div className={styles.inputIcon}>
					<svg
						className={styles.clickable}
						onClick={handleVisibilityIconClick}
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2.5 8.68009C5.69353 12.0756 10.3065 12.0756 13.5 8.68009M2.5 5.08188C4.09677 3.38408 6.0484 2.53517 8 2.53516C9.9516 2.53514 11.9033 3.384 13.5 5.08175M8 11.3335V13.5002M5.50003 11.0002L4.50003 12.6549M10.3333 11.0002L11.5 12.6549"
							stroke="#FF7926"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
			)}
			{
				button && (
					button.verified ? (
						<CheckedIcon />
					) : (
						<button className={styles.button} onClick={button.function}>
							{button.label}
						</button>
					)
				)
			}
		</button>
	);
});

export default Input;
